import { render } from "./DesignElementProps.vue?vue&type=template&id=2d3432ca&scoped=true"
import script from "./DesignElementProps.vue?vue&type=script&lang=js"
export * from "./DesignElementProps.vue?vue&type=script&lang=js"

import "./DesignElementProps.vue?vue&type=style&index=0&id=2d3432ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3432ca"]])

export default __exports__